module.exports = __webpack_public_path__ + "img/guanzhao.254e2a45.png";